module.exports = __webpack_public_path__ + "static/media/crossGrayWithBg.965c4712.png";